import SectionOne from './sections/SectionOne';
import SectionTwo from './sections/SectionTwo';
import SectionThree from './sections/SectionThree';
import SectionFour from './sections/SectionFour';
import SectionFive from './sections/SectionFive';
import SectionSix from './sections/SectionSix';
import SectionSeven from './sections/SectionSeven';
import Footer from '@components/Footer/Footer';
import Banner from '@components/Banner/banner';
import { useTranslation } from 'react-i18next';
import Laptop from '../../assets/images/laptop.png';

function Home() {
  const { t } = useTranslation('home');
  return (
    <>
      <Banner
        title={t('home.title')}
        paragraph={t('home.subtitle')}
        isHome={true}
      >
        <img src={Laptop} alt="laptop" />
      </Banner>
      <SectionOne />
      <SectionTwo />
      <SectionThree />
      <SectionFour />
      <SectionFive />
      <SectionSix />
      <SectionSeven />
      <Footer />
    </>
  );
}

export default Home;
